// ProtectedRoute.js
import { useSelector } from "react-redux";
import styled from "styled-components";
import Footer from "./shared/Footer";
import Navbar from "./shared/Navbar";

const ProtectedRoute = ({ children }) => {
  const { user, loading, hasChecked } = useSelector((state) => state.auth);
  const localUser = JSON.parse(localStorage.getItem("vendor") || "null");

  if (!hasChecked || loading) {
    return null; // or a loading spinner
  }

  if (!user) {
    // test
    window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    return null;
  }

  if (user || localUser?._id) {
    return (
      <PageLayout>
        <Navbar />
        <Main>{children}</Main>
        <Footer />
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Navbar />
      <Main>{children}</Main>
      <Footer />
    </PageLayout>
  );
};

export default ProtectedRoute;

const Main = styled.main`
  padding-top: 89px;
  flex: 1;
  @media (max-width: 768px) {
    padding-top: 72px;
  }
`;

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
